/** @jsx createElement */
import { observer } from 'mobx-react';
import { createElement, Component, HTMLAttributes } from 'react';
import ReactDOM from 'react-dom';
import { KeyboardShortcuts } from '../keyboard-shortcuts';
import anime from 'animejs';
import { activate, deactivate, shimmer, activateShimmer } from '../helpers';
import { AnimatedSlide } from '../animated-slide';
import { PlayerDataMoving } from '../players/data-moving';
import { PlayerTextLines } from '../players/text-lines';
import { PlayerTextBlock } from '../players/text-block';

// SVG
import { Page } from '../svg/page';

@observer
export class Slide07 extends AnimatedSlide {
  // Animation players
  players = {
    dataLeft: null,
    tcp: null,
    file: null,
    seq: null,
  };

  // Run the first animation
  componentDidMount() {
    const { dataLeft, tcp, file, seq } = this.players;

    this.steps = [
      // Slide 1
      () => {
        this.animateProgress(4000);
        this.autoNext(2000);
      },
      // Step 2
      () => {
        this.autoNext(1000);
      },
      // Step 3
      () => {},
    ];

    this.animations = [
      //
      // Step 1
      //
      [],

      //
      // Step 2
      //
      [
        {
          targets: tcp,
          easing: 'easeOutQuad',
          opacity: 1,
          top: 290,
          duration: 200,
          delay: 50,
        },
        {
          targets: file,
          easing: 'easeOutQuad',
          opacity: 1,
          top: 370,
          duration: 200,
          delay: 0,
          begin: activateShimmer,
        },
      ],

      //
      // Step 3
      //
      [
        {
          targets: tcp,
          easing: 'easeOutQuad',
          opacity: 1,
          top: 270,
          duration: 200,
          delay: 0,
        },
        {
          targets: file,
          easing: 'easeOutQuad',
          opacity: 1,
          top: 350,
          duration: 200,
          delay: 0,
        },
        {
          targets: seq,
          easing: 'easeOutQuad',
          opacity: 1,
          top: 450,
          duration: 200,
          delay: 0,
          begin: activateShimmer,
        },
      ],
    ];

    // Play the first animation
    this.play();
  }

  render() {
    const { children, className = '' } = this.props;

    let tcpSettings = {
      title: 'TCP STREAM',
      sections: [
        {
          title: '50993 - http [rst,ack]',
        },
      ],
    };

    let seqSettings = {
      sections: [
        {
          title: 'Seq=1 Ack=1 Win=0 Lens=0',
        },
      ],
    };

    let fileSettings = {
      sections: [
        {
          title: ['DESTINATION', '8.253.140.248'],
          grid: 2,
          lines: 3,
          lineColumns: 2,
        },
      ],
    };

    return (
      <div className={`slide-07 ${className}`}>
        {children}
        <div className="content">
          {/* Text Block */}
          <div
            className="player seq"
            data-active="0"
            ref={node => (this.players.seq = node)}
          >
            <PlayerTextBlock {...seqSettings} />
          </div>

          {/* File found */}
          <div
            className="player file"
            data-active="0"
            ref={node => (this.players.file = node)}
          >
            <PlayerTextBlock {...fileSettings} />
          </div>

          {/* Text Block */}
          <div
            className="player tcp"
            data-active="1"
            ref={node => (this.players.tcp = node)}
          >
            <PlayerTextBlock {...tcpSettings} />
          </div>

          {/* Left data moving */}
          <div
            className="player data-left"
            data-active="1"
            ref={node => (this.players.dataLeft = node)}
          >
            <PlayerDataMoving wait="0" />
          </div>
        </div>
      </div>
    );
  }
}
